// src/components/gamification/RewardCard.tsx
import React from 'react';
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Button,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import { Reward } from '../../services/interfaces';

interface RewardCardProps {
    reward: Reward;
    onClaim: (rewardId: number) => Promise<void>;
    userPoints: number;
}

export const RewardCard: React.FC<RewardCardProps> = ({ reward, onClaim, userPoints }) => {
    const [open, setOpen] = React.useState(false);
    const [claiming, setClaiming] = React.useState(false);

    const handleClaim = async () => {
        try {
            setClaiming(true);
            await onClaim(reward.id);
            setOpen(false);
        } catch (error) {
            console.error('Failed to claim reward:', error);
        } finally {
            setClaiming(false);
        }
    };

    return (
        <>
            <Card sx={{
                maxWidth: 345,
                opacity: reward.available ? 1 : 0.6,
                transition: 'transform 0.2s',
                '&:hover': {
                    transform: reward.available ? 'scale(1.02)' : 'none'
                }
            }}>
                <CardMedia
                    component="img"
                    height="140"
                    image={reward.imageUrl}
                    alt={reward.name}
                />
                <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                        {reward.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {reward.description}
                    </Typography>
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" color="primary">
                            {reward.pointsCost} поена
                        </Typography>
                        <Button
                            variant="contained"
                            disabled={!reward.available || userPoints < reward.pointsCost}
                            onClick={() => setOpen(true)}
                        >
                            Преузми награду
                        </Button>
                    </Box>
                </CardContent>
            </Card>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Преузми награду</DialogTitle>
                <DialogContent>
                    <Typography>
                        Јесте ли сигурни да желите да преузмете награду {reward.name} за {reward.pointsCost} поена?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={claiming}>
                        Одустани
                    </Button>
                    <Button onClick={handleClaim} color="primary" disabled={claiming}>
                        {claiming ? 'Claiming...' : 'Преузми'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};